import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

export interface KitComponentData {
  product_id: number;
  quantity: number;
  inventory_floor?: number;
  kit_configuration_id: number;
}

export interface KitComponent extends KitComponentData {
  id: number;
  sku: string;
  created_at?: string;
  created_by?: string;
  updated_at?: string;
  updated_by?: string;
}

export const createKitComponent = async (
  scope: RequestScope,
  data: KitComponentData,
  options: WriteRequestOptions
): Promise<EndpointResponse<KitComponent>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<KitComponent>>('/kit_component', data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
